module.exports = __webpack_public_path__ + "static/media/webdesign-services-img19.a685ccde.jpg";